function emptyAction() {
  console.warn("Current execute action is empty!");
}
class Actions {
  constructor() {
    this.actions = {
      onGlobalStateChange: emptyAction,
      setGlobalState: emptyAction
    };
  }
  setActions(actions2) {
    this.actions = actions2;
  }
  onGlobalStateChange(...args) {
    return this.actions.onGlobalStateChange(...args);
  }
  setGlobalState(...args) {
    return this.actions.setGlobalState(...args);
  }
}
const actions = new Actions();
export { actions };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/qiankun/action.js